(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["class-calendar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var FULL_TITLE = {
    "Intro Wheel": "Intro to Wheel Throwing",
    "Thrown & Altered": "Thrown & Altered: Wheel + Handbuilding",
    "Handbuilding": "Intro to Handbuilding",
    "Face Mugs": "Hand Built Face Mugs",
    "Pumpkin Lantern": "Handbuilt Pumpkin Lantern",
    "One Night Wheel": "Try the Pottery Wheel",
    "First Friday": "First Friday"
  };

  var MONTHS = [
    { key: "2026-09", year: 2026, month: 9, label: "September" },
    { key: "2026-10", year: 2026, month: 10, label: "October" },
    { key: "2026-11", year: 2026, month: 11, label: "November" }
  ];

  var DOW = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  var TOTAL_WEEKS = 6;
  var FF_NOTE = "Members plus one free guest, 4–9 PM, with instructor minis.";
  var MEMBER_NOTE = "Free for members. No free guest; that perk is First Fridays only, 4–9 PM.";
  var EMPTY_DAY = "No classes this day.";

  function esc(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function pad(n) {
    return n < 10 ? "0" + n : String(n);
  }

  function isoDate(year, month, day) {
    return year + "-" + pad(month) + "-" + pad(day);
  }

  function parseIso(iso) {
    var p = iso.split("-").map(Number);
    return { year: p[0], month: p[1], day: p[2] };
  }

  function groupDateLabel(iso) {
    var p = parseIso(iso);
    var dt = new Date(p.year, p.month - 1, p.day);
    return dt.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric"
    });
  }

  function longDate(iso) {
    var p = parseIso(iso);
    var dt = new Date(p.year, p.month - 1, p.day);
    return dt.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric"
    });
  }

  function isFf(ev) {
    return ev.weekLabel === "FF" || ev.titleShort === "First Friday";
  }

  // Members-only events that are not First Friday (e.g. Member Wheel). No free guest.
  function isMember(ev) {
    return !isFf(ev) && ev.membersOnly === true;
  }

  function eventKind(ev) {
    if (isFf(ev)) return "ff";
    if (isMember(ev)) return "member";
    if (!ev.weekLabel) return "night";
    return "class";
  }

  function todayIsoLocal() {
    var d = new Date();
    return isoDate(d.getFullYear(), d.getMonth() + 1, d.getDate());
  }

  function defaultMonthIndex(events) {
    var today = todayIsoLocal();
    var i;
    for (i = 0; i < MONTHS.length; i++) {
      if (MONTHS[i].key === today.slice(0, 7)) return i;
    }
    // else first month that still has an event on/after today
    for (i = 0; i < MONTHS.length; i++) {
      var key = MONTHS[i].key;
      var hasFuture = events.some(function (ev) {
        return String(ev.date).slice(0, 7) === key && ev.date >= today;
      });
      if (hasFuture) return i;
    }
    return 0;
  }

  function startMinutes(time) {
    var start = String(time).split("–")[0].trim();
    var parts = start.match(/(\d+)(?::(\d+))?/);
    if (!parts) return 0;
    var h = parseInt(parts[1], 10);
    var m = parts[2] ? parseInt(parts[2], 10) : 0;
    if (/PM/i.test(time) && h < 12) h += 12;
    if (/AM/i.test(time) && h === 12) h = 0;
    return h * 60 + m;
  }

  function sortEvents(list) {
    return list.slice().sort(function (a, b) {
      return startMinutes(a.time) - startMinutes(b.time);
    });
  }

  function groupByDate(events) {
    var map = {};
    events.forEach(function (ev) {
      if (!map[ev.date]) map[ev.date] = [];
      map[ev.date].push(ev);
    });
    Object.keys(map).forEach(function (k) {
      map[k] = sortEvents(map[k]);
    });
    return map;
  }

  function prefersReduce() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function productUrl(root, handle) {
    if (!handle) return "";
    var base = (root.getAttribute("data-product-base") || "").replace(/\/$/, "");
    if (!base || base === "/") base = "";
    return base + "/products/" + handle;
  }

  function membershipUrl(root) {
    var base = (root.getAttribute("data-product-base") || "").replace(/\/$/, "");
    if (!base || base === "/") base = "";
    return base + "/products/pottery-studio-membership-claya-denver-colorado";
  }

  // "W1" -> "Week 1 of N" (per-event totalWeeks, else TOTAL_WEEKS).
  function weekPhrase(label, ev) {
    var m = String(label == null ? "" : label).match(/^W(\d+)$/i);
    var total = (ev && ev.totalWeeks) || TOTAL_WEEKS;
    return m ? "Week " + m[1] + " of " + total : label;
  }

  function eventMeta(ev) {
    if (isFf(ev)) {
      return ev.time || "4–9 PM";
    }
    var bits = [];
    if (ev.time) bits.push(ev.time);
    if (ev.instructor) bits.push(ev.instructor);
    if (ev.weekLabel) bits.push(weekPhrase(ev.weekLabel, ev));
    if (ev.soldOut) bits.push("Sold out");
    return bits.join(" · ");
  }

  function eventHtml(root, ev) {
    var title = ev.titleFull || FULL_TITLE[ev.titleShort] || ev.titleShort;
    var kind = eventKind(ev);
    var html = '<article class="claya-cal__event">';
    if (isFf(ev) || isMember(ev)) {
      html += '<span class="claya-cal__event-badge">Members only</span>';
    } else if (kind === "night") {
      html += '<span class="claya-cal__event-badge">One night</span>';
    }
    html += '<h4 class="claya-cal__event-name">' + esc(title) + "</h4>";
    html += '<p class="claya-cal__event-meta">' + esc(eventMeta(ev)) + "</p>";
    if (isFf(ev) || isMember(ev)) {
      html += '<p class="claya-cal__event-note">' + esc(isFf(ev) ? FF_NOTE : MEMBER_NOTE) + "</p>";
      html +=
        '<a class="claya-cal__event-link" href="' +
        esc(membershipUrl(root)) +
        '">Membership info</a>';
    } else {
      var href = productUrl(root, ev.productHandle);
      if (href) {
        html +=
          '<a class="claya-cal__event-link" href="' +
          esc(href) +
          '">Book class</a>';
      }
    }
    html += "</article>";
    return html;
  }

  function groupHtml(root, iso, events) {
    var html = '<section class="claya-cal__group">';
    html += '<h3 class="claya-cal__group-date">' + esc(groupDateLabel(iso)) + "</h3>";
    events.forEach(function (ev) {
      html += eventHtml(root, ev);
    });
    html += "</section>";
    return html;
  }

  function dotHtml(ev) {
    var kind = eventKind(ev);
    var cls = "claya-cal__dot claya-cal__dot--" + kind;
    return '<span class="' + cls + '"></span>';
  }

  function buildCells(year, month) {
    // Leading blanks so day 1 sits under its real weekday. Without them the
    // whole month shifts left and Sept 4 (a Friday) renders under Wednesday.
    var first = new Date(year, month - 1, 1, 12, 0, 0);
    var firstDow = first.getDay();
    var daysIn = new Date(year, month, 0).getDate();
    var cells = [];
    var i;
    for (i = 0; i < firstDow; i++) cells.push(null);
    for (i = 1; i <= daysIn; i++) {
      cells.push({ day: i, iso: isoDate(year, month, i) });
    }
    while (cells.length % 7 !== 0) cells.push(null);
    return cells;
  }

  function init(root) {
    if (!root || root.getAttribute("data-claya-cal-ready") === "true") return;
    var jsonEl = root.querySelector("[data-claya-cal-events]");
    if (!jsonEl) return;
    var events;
    try {
      events = JSON.parse(jsonEl.textContent);
    } catch (err) {
      return;
    }
    var byDate = groupByDate(events);
    var monthIndex = defaultMonthIndex(events);
    var selectedIso = null;
    var fadeToken = 0;
    var switchEl = root.querySelector("[data-claya-switch]");
    var dowEl = root.querySelector("[data-claya-dow]");
    var gridEl = root.querySelector("[data-claya-grid]");
    var panelEl = root.querySelector("[data-claya-panel]");
    if (!switchEl || !dowEl || !gridEl || !panelEl) return;

    dowEl.innerHTML = DOW.map(function (d) {
      return "<span>" + d + "</span>";
    }).join("");

    function renderSwitch() {
      var keepFocus = document.activeElement && switchEl.contains(document.activeElement);
      switchEl.innerHTML =
        '<div class="claya-cal__months" role="tablist" aria-label="Class calendar month, 2026">' +
        MONTHS.map(function (m, i) {
          return (
            '<button type="button" class="claya-cal__month" role="tab" id="' +
            esc(root.id || "claya-cal") +
            "-m-" +
            i +
            '" aria-selected="' +
            (i === monthIndex ? "true" : "false") +
            '" data-month-index="' +
            i +
            '">' +
            esc(m.label) +
            "</button>"
          );
        }).join("") +
        "</div>";
      if (keepFocus) {
        var activeBtn = switchEl.querySelector('[data-month-index="' + monthIndex + '"]');
        if (activeBtn) activeBtn.focus();
      }
    }

    function ariaForDay(iso, list) {
      var label = longDate(iso);
      if (!list.length) return label + ". No classes this day.";
      var bits = list.map(function (ev) {
        if (isFf(ev)) return "First Friday";
        if (isMember(ev)) return (ev.titleFull || ev.titleShort) + ", members only";
        return [weekPhrase(ev.weekLabel, ev), ev.titleShort, ev.instructor].filter(Boolean).join(" ");
      });
      return label + ". " + bits.join(". ");
    }

    function renderGrid() {
      var spec = MONTHS[monthIndex];
      var cells = buildCells(spec.year, spec.month);
      gridEl.setAttribute("role", "region");
      gridEl.setAttribute("aria-label", spec.label + " 2026 class calendar");
      gridEl.innerHTML = cells
        .map(function (cell) {
          if (!cell) return '<div class="claya-cal__empty" aria-hidden="true"><span></span></div>';
          var list = byDate[cell.iso] || [];
          var pressed = selectedIso === cell.iso ? "true" : "false";
          var quiet = !list.length;
          var dots = quiet
            ? ""
            : '<span class="claya-cal__dots">' + list.map(dotHtml).join("") + "</span>";
          return (
            '<button type="button" class="claya-cal__day' +
            (quiet ? " is-quiet" : "") +
            '" data-iso="' +
            cell.iso +
            '" aria-pressed="' +
            pressed +
            '" aria-label="' +
            esc(ariaForDay(cell.iso, list)) +
            '">' +
            '<span class="claya-cal__num">' +
            cell.day +
            "</span>" +
            dots +
            "</button>"
          );
        })
        .join("");
    }

    function renderPanel() {
      if (!selectedIso) {
        panelEl.innerHTML =
          '<p class="claya-cal__panel-empty">Pick a day to see what’s on, then book from here.</p>';
        return;
      }
      var dayList = byDate[selectedIso] || [];
      if (!dayList.length) {
        panelEl.innerHTML = '<p class="claya-cal__panel-empty">' + esc(EMPTY_DAY) + "</p>";
        return;
      }
      panelEl.innerHTML = groupHtml(root, selectedIso, dayList);
    }

    function paint(withFade) {
      renderSwitch();
      renderPanel();
      var token = ++fadeToken;
      var run = function () {
        if (token !== fadeToken) return;
        renderGrid();
        gridEl.classList.remove("is-fading");
      };
      if (withFade && !prefersReduce()) {
        gridEl.classList.add("is-fading");
        window.setTimeout(run, 150);
      } else {
        run();
      }
    }

    function selectDay(iso) {
      selectedIso = selectedIso === iso ? null : iso;
      renderGrid();
      renderPanel();
    }

    function clearFilter() {
      if (!selectedIso) return;
      selectedIso = null;
      renderGrid();
      renderPanel();
    }

    function setMonth(next, fade) {
      if (next < 0 || next >= MONTHS.length || next === monthIndex) return;
      monthIndex = next;
      selectedIso = null;
      paint(fade);
    }

    switchEl.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-month-index]");
      if (!btn || !switchEl.contains(btn)) return;
      setMonth(parseInt(btn.getAttribute("data-month-index"), 10), true);
    });

    switchEl.addEventListener("keydown", function (e) {
      if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
      var btn = e.target.closest("[data-month-index]");
      if (!btn) return;
      e.preventDefault();
      var dir = e.key === "ArrowRight" ? 1 : -1;
      var next = monthIndex + dir;
      if (next < 0) next = MONTHS.length - 1;
      if (next >= MONTHS.length) next = 0;
      setMonth(next, true);
    });

    gridEl.addEventListener("click", function (e) {
      var btn = e.target.closest(".claya-cal__day");
      if (!btn || !gridEl.contains(btn)) return;
      selectDay(btn.getAttribute("data-iso"));
    });

    root.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && selectedIso) {
        clearFilter();
      }
    });

    root.setAttribute("data-claya-cal-ready", "true");
    paint(false);
  }

  function initAll(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll ? root.querySelectorAll("[data-claya-cal]") : [];
    if (root.matches && root.matches("[data-claya-cal]")) init(root);
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (e && e.target) initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
